import React from 'react'

const CompCtx = React.createContext({
    dishCartCtx: [], 
    setDishCartCtx: () => {},
})

export default CompCtx              